import { render, staticRenderFns } from "./EstatementFeeReductionRewardEditor.vue?vue&type=template&id=409e2e96&scoped=true"
import script from "./EstatementFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./EstatementFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409e2e96",
  null
  
)

export default component.exports